import { render, staticRenderFns } from "./SidebarSeller.vue?vue&type=template&id=3537d7a0&scoped=true"
import script from "./SidebarSeller.vue?vue&type=script&lang=js"
export * from "./SidebarSeller.vue?vue&type=script&lang=js"
import style0 from "./SidebarSeller.vue?vue&type=style&index=0&id=3537d7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3537d7a0",
  null
  
)

export default component.exports